import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import { DateTime, Duration } from 'luxon'

// Components

const TimeContainer = styled.div`
  position: absolute;
  top: 0; right: 0;
  margin: 0 4vw;
  padding: 3vw 0;

  font-size: .8em;
  text-align: right;
  text-shadow: 1px 1px ${props => props.theme.textShadow};

  .now {
    font-weight: bold;
    cursor: pointer;
    margin: 7px 0;
  }
  .time-detail {
    display: none;
    list-style: none;
    margin: 0;
    li {
      margin: 0;
    }
  }

  .now:hover .time-detail {
    display: block;
  }
`;


class Time extends Component {
  constructor(props) {
    super(props);

    this.state = {
      local: null,
      vienna: null,
      offset: null
    };
  }

  renderTime() {
    // Render Local Time
    let local = DateTime.local();
    let vienna = local.setZone('Europe/Vienna', { keepLocalTime: false });
    let offset = 0;

    if (local.offset > 0 && vienna.offset > 0 ||
        local.offset < 0 && vienna.offset < 0) {
      offset = Math.abs(local.offset / 60) - Math.abs(vienna.offset / 60)
    } else {
      offset = Math.abs(local.offset / 60) + Math.abs(vienna.offset / 60)
    }

    this.setState({
      local: local.toLocaleString(DateTime.TIME_SIMPLE),
      vienna: vienna.toLocaleString(DateTime.TIME_SIMPLE),
      offset: offset
    });
  }

  componentDidMount() {
    this.renderTime();
    var intervalId = setInterval(this.renderTime.bind(this), 1000);
    this.setState({intervalId: intervalId});
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  render() {
    return(
      <TimeContainer>
        <div className="now">
          <span>{this.state.vienna}</span>

          <ul className="time-detail">
            <li>Locatime: {this.state.local}</li>
            <li>Difference: {this.state.offset}HRS</li>
          </ul>
        </div>
      </TimeContainer>
    )
  }
}

export default Time


// WEBPACK FOOTER //
// ./src/components/Time/index.js